import React, { useState, useEffect, useCallback } from "react";
import { API_BASE_URL } from "../config";

export default function RequestforpriceForm({
  productCode,
  designCode,
  productId,
  productImg,
  initialValues = null,
  requestId = 0,
  onClose,
}) {
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");

  const isEditMode = Boolean(initialValues);

  const [loading, setLoading] = useState(false);
  const [diamondTypes, setDiamondTypes] = useState([]);
  const [diamondQualities, setDiamondQualities] = useState([]);

  const [form, setForm] = useState({
    userId: storedUser.userId || "",
    companyId: storedUser.companyId || "",
    metalColor: "",
    metalKT: "",
    diamondId: "",
    diamondName: "",
    clarity: "",
    color: "",
    carat: "",
    size: "",
    comment: "",
  });

  /* ---------------- FETCH DIAMONDS ---------------- */
  const fetchDiamondTypes = useCallback(async () => {
    const res = await fetch(`${API_BASE_URL}/Master/GetDiamond`);
    const json = await res.json();
    setDiamondTypes(json.data || []);
  }, []);

  /* ---------------- FETCH CLARITY ---------------- */
  const fetchClarity = useCallback(async (diamondId) => {
    if (!diamondId) {
      setDiamondQualities([]);
      return;
    }
    const res = await fetch(
      `${API_BASE_URL}/Master/GetClaritys?Diamondid=${diamondId}`
    );
    const json = await res.json();
    setDiamondQualities(json.data || []);
  }, []);

  /* ---------------- INITIAL LOAD ---------------- */
  useEffect(() => {
    fetchDiamondTypes();
  }, [fetchDiamondTypes]);

  /* ---------------- PREFILL EDIT ---------------- */
  useEffect(() => {
    if (!initialValues || !diamondTypes.length) return;

    const matchedDiamond = diamondTypes.find(
      (d) => d.name === initialValues.DiamondType
    );

    setForm({
      userId: storedUser.userId || "",
      companyId: storedUser.companyId || "",
      metalColor: initialValues.MetalColor || "",
      metalKT: initialValues.MetalKT || "",
      diamondId: matchedDiamond?.id || "",
      diamondName: initialValues.DiamondType || "",
      clarity: initialValues.Clarity || "",
      color: initialValues.Color || "",
      carat: initialValues.Carat || "",
      size: initialValues.Size || "",
      comment: initialValues.Comment || "",
    });

    if (matchedDiamond?.id) {
      fetchClarity(matchedDiamond.id);
    }
  }, [initialValues, diamondTypes, fetchClarity]);

  /* ---------------- HANDLE CHANGE ---------------- */
  const handleChange = (e) => {
    const { id, value } = e.target;

    if (id === "diamond") {
      const selected = diamondTypes.find((d) => d.id == value);

      setForm((prev) => ({
        ...prev,
        diamondId: value,
        diamondName: selected?.name || "",
        clarity: "",
      }));

      fetchClarity(value);
      return;
    }

    setForm((prev) => ({ ...prev, [id]: value }));
  };

  /* ---------------- SUBMIT ---------------- */
  const handleSubmit = async () => {
    const payload = {
      Id: requestId || 0,
      ProductId: productId,
      ProductImg: productImg,
      ProductCode: productCode,
      DesignCode: designCode,
      UserId: form.userId || 0,
      CompanyId: form.companyId,
      MetalColor: form.metalColor,
      MetalKT: form.metalKT,
      DiamondType: form.diamondName, // ✅ NAME STORED
      Clarity: form.clarity,
      Color: form.color,
      Carat: parseFloat(form.carat || 0),
      Size: form.size,
      Comment: form.comment,
      CreatedBy: requestId ? null : "Customer",
      UpdatedBy: requestId ? "Customer" : null
      
    };

    try {
      setLoading(true);
      const res = await fetch(
        `${API_BASE_URL}/Price/InsertUpdateReqOfPrice`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (res.ok) {
          const data = await res.json();
      console.log(data);
        alert(isEditMode ? "Request updated successfully" : "Request submitted successfully");
        onClose();
        window.dispatchEvent(new Event("markupTableChanged"));
      } else {
          const err = await res.text();
      console.log(err);
        alert("Failed to save request");
      }
    } catch (err) {
      console.error(err);
      alert("API error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h4 className="modal-title">{isEditMode ? "Edit Request For Price" : "Request For Any Modification"}</h4>
<br/>
      <div className="row mb-2">
        <div className="col-md-4">
          <label>Metal Color</label>
          <select
            id="metalColor"
            className="form-control"
            value={form.metalColor}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="Yellow">Yellow</option>
            <option value="White">White</option>
            <option value="Rose">Rose</option>
          </select>
        </div>

        <div className="col-md-4">
          <label>Metal KT</label>
          <select
            id="metalKT"
            className="form-control"
            value={form.metalKT}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="9KT">9 KT</option>
            <option value="10KT">10 KT</option>
            <option value="14KT">14 KT</option>
            <option value="18KT">18 KT</option>
          </select>
        </div>

        <div className="col-md-4">
          <label>Size</label>
          <select
            id="size"
            className="form-control"
            value={form.size}
            onChange={handleChange}
          >
            <option value="">Select</option>
            {["R","Q","P","O","N","M","L","K","J","I","H"].map(s => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-md-4">
          <label>Diamond Type</label>
          <select
            id="diamond"
            className="form-control"
            value={form.diamondId}
            onChange={handleChange}
          >
            <option value="">Select Diamond Type</option>
            {diamondTypes.map(d => (
              <option key={d.id} value={d.id}>{d.name}</option>
            ))}
          </select>
        </div>

        <div className="col-md-4">
          <label>Clarity</label>
          <select
            id="clarity"
            className="form-control"
            value={form.clarity}
            onChange={handleChange}
          >
            <option value="">Select Clarity</option>
            {diamondQualities.map(q => (
              <option key={q.id} value={q.name}>{q.name}</option>
            ))}
          </select>
        </div>

        <div className="col-md-4">
          <label>Color</label>
          <select
            id="color"
            className="form-control"
            value={form.color}
            onChange={handleChange}
          >
            <option value="">Select Color</option>
            {["D","E","F","G","H","I","J","K","L","M","EF","FG","GH","HI","IJ","JK","WH","I1"].map(c => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </div>

        <div className="col-md-4 mt-2">
          <label>Carat</label>
          <input
            id="carat"
            type="number"
            step="0.01"
            className="form-control"
            value={form.carat}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="mb-2">
        <label>Comment</label>
        <textarea
          id="comment"
          className="form-control"
          rows="3"
          value={form.comment}
          onChange={handleChange}
        />
      </div>

      <div className="text-end">
        <button className="btn btn-secondary me-2" onClick={onClose}>
          Cancel
        </button>
        <button className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Saving..." : isEditMode ? "Update" : "Submit"}
        </button>
      </div>
    </>
  );
}
